import React, { ReactNode } from "react"
import { OrderShippingKlarnaShippingAssistant } from "lib/types/generated/graphql-types"
import CopyButton from "components/Ui/CopyButton"
import { getCountryName } from "helpers/countries"
import { ChildrenWrapper, Container, Row, StyledKustomLogo, Title } from "./Styled"

type Props = {
  shippingKlarna: OrderShippingKlarnaShippingAssistant | undefined
}

const KustomShippingAssistantDetails = ({ shippingKlarna }: Props) => {
  const getItem = (title: string, children: ReactNode) => {
    return (
      <div>
        <>
          <div>{title}</div>
          <div>{children}</div>
        </>
      </div>
    )
  }

  return (
    <>
      <Title $logoMargin={"0 0.8rem 0.3rem 0.5rem"}>
        <StyledKustomLogo /> details
      </Title>
      <Container>
        <Row>
          {getItem(
            "Reference",
            <b>
              {shippingKlarna?.reference} <CopyButton string={shippingKlarna?.reference} />
            </b>
          )}
          {getItem(
            "Kustom Merchant ID",
            <b>
              {shippingKlarna?.klarnaMerchantId}{" "}
              <CopyButton string={shippingKlarna?.klarnaMerchantId} />
            </b>
          )}
        </Row>
        <Row>
          {getItem(
            "Selected shipping",
            <ChildrenWrapper>
              <b> {shippingKlarna?.selectedShippingOption?.name} </b>
              <b> {shippingKlarna?.selectedShippingOption?.carrier} </b>
              <b>{shippingKlarna?.selectedShippingOption.carrierProduct?.name}</b>
            </ChildrenWrapper>
          )}
          {getItem(
            "Location",
            <ChildrenWrapper>
              <b>{shippingKlarna?.selectedShippingOption?.location?.name} </b>
              <b>{shippingKlarna?.selectedShippingOption?.location?.address?.streetAddress} </b>
              <b>{shippingKlarna?.selectedShippingOption?.location?.address?.streetAddress2} </b>
              <b>
                {shippingKlarna?.selectedShippingOption?.location?.address?.postalCode}{" "}
                {shippingKlarna?.selectedShippingOption?.location?.address?.city}
              </b>
              <b>{shippingKlarna?.selectedShippingOption?.location?.address?.region} </b>
              {shippingKlarna?.selectedShippingOption?.location?.address?.country && (
                <b>
                  {getCountryName(
                    shippingKlarna?.selectedShippingOption?.location?.address?.country
                  )}
                </b>
              )}
            </ChildrenWrapper>
          )}
        </Row>
      </Container>
    </>
  )
}

export default KustomShippingAssistantDetails
